import * as Container from './route.container';
import * as Component from './route.component';
import * as Reducer from './router.reducer';
import * as Constants from './router.constants';
import * as Epics from './router.epic';

export { Container, Component, Reducer, Constants, Epics };

export default Container.default;
